import type {
  OrderInfoModel,
  OrderInfoStatusModel,
  OrderModel,
  OrderStatusModel,
} from '@merchant-clients/order';

const orderInfoStatusToOrderStatus = {
  wait_customer_confirm: 'PENDING',
  wait_charge_auth: 'PENDING',
  wait_3d_secure: 'PENDING',
  wait_shop_confirm: 'PENDING',
  wait_delivery_confirm: 'CONFIRMED',
  wait_charge_capture: 'CONFIRMED',
  wait_packaging: 'CONFIRMED',
  wait_delivery_pickup: 'READY',
  delivered: 'CLOSED',
  customer_cancelled: 'REJECTED',
  customer_charge_cancelled: 'REJECTED',
  payment_failed: 'REJECTED',
  shop_cancelled: 'REJECTED',
  shop_rejected: 'REJECTED',
  shop_timedout: 'REJECTED',
  delivery_rejected: 'REJECTED',
  fsgm_failed: 'REJECTED',
  refunded: 'REFUNDED',
} satisfies Record<OrderInfoStatusModel, OrderStatusModel>;

export const mapOrderInfoToOrder = (order: OrderInfoModel): OrderModel => {
  return {
    id: order.id,
    guestName: order.guestName,
    guestEmail: order.guestEmail,
    guestPhone: order.guestPhone,
    placeIds: order.places?.map((place) => place.id) ?? [],
    placeNames: order.places?.map((place) => place.name) ?? [],
    status: orderInfoStatusToOrderStatus[order.status],
    total: order.total,
    tax: order.tax,
    verification: order.verification,
    items: order.items.map((item, itemIndex) => ({
      id: item.id,
      name: item.name,
      quantity: item.quantity,
      options: item.options?.map((option, optionIndex) => ({
        id: `${itemIndex}-${optionIndex}`,
        name: option.name,
        quantity: option.quantity,
      })),
    })),
    deliveryOption: order.deliveryOption,
    timeRequested: order.timeRequested,
    createdAt: order.createdAt,
    deliveredAt: order.deliveredAt,
    message: order.message,
    loadingState: false,
  };
};
